import { Button, Modal, Typography } from 'antd';

interface ModalProps {
  isOpen: boolean;
  toggleModal: () => void;
  id: string;
  handleChange: (id: string) => void;
  label: string;
}

const ConfirmModal: React.FC<ModalProps> = ({ isOpen, id, toggleModal, handleChange, label }) => {
  const handleClick = () => {
    handleChange(id);
    toggleModal();
  };

  return (
    <Modal
      closable={false}
      open={isOpen}
      onCancel={toggleModal}
      footer={[
        <Button key="yes" onClick={handleClick}>
          Yes
        </Button>,
        <Button key="no" type="primary" onClick={toggleModal}>
          No
        </Button>,
      ]}
    >
      <div className="flex-col  gap-16">
        <Typography className="text-l">{label}</Typography>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
